/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Masks from '../../utils/masks';
import {
  Button,
  DataGrid,
  Grid,
  Input,
} from '../../components/index';
import {
  tipoCtc,
  sexo,
  ufs,
} from '../../utils/listsSelect';
import User from '../../domain/User';

const jssPainelMensagemCampoRGPS = {
  display: 'flex',
  padding: '22x',
  borderRadius: '5px',
  backgroundColor:'#e29402',
  color: 'white',
  height: '50px',
  verticalAlign: 'middle',
  marginBottom: '20px',
};

const jssPainelMensagemCampoRPPS = {
  display: 'flex',
  padding: '22x',
  borderRadius: '5px',
  backgroundColor:'#e29402',
  color: 'white',
  height: '80px',
  verticalAlign: 'middle',
  marginBottom: '20px',
};

const jssMensagemDescricao = {
  display: 'inline-block',
  textAlign: 'left',
  verticalAlign: 'middle',
  fontWeight: '600',
  paddingTop: '12px',
  fontSize: '15px',
  marginLeft: '10px',
  flexGrow: '0',
};

const jssCarimboSituacaoCtc = {
  display: 'inline-block',
  textAlign: 'center',
  verticalAlign: 'middle',
  width: '100%',
};

const DadosRepositorioCtc = (props) => {
  const verificaSeCampoDesabilitado = (name) => {
    const { acao } = { ...props };

    if (acao === 'detalhar-ctc' || acao === 'detalhar-ctc-invalida') {
      return true;
    }

    if (acao === 'editar-rascunho') {
      if (name === 'cpf') {
        return true;
      }
      return false;
    }

    return false;
  };

  const acao = { MARCAR: 'marcar', DESMARCAR: 'desmarcar' };
  const checked = (props.statePrincipal.informarSegundaMatricula && props.statePrincipal.informarSegundaMatricula === 1);
  const acaoAoClicar = checked ? acao.DESMARCAR : acao.MARCAR;

  const checkedNomeMae = (props.statePrincipal.ctc.nomeMaeInexistente && props.statePrincipal.ctc.nomeMaeInexistente === 1);
  const acaoAoClicarNomeMae = checkedNomeMae ? acao.DESMARCAR : acao.MARCAR;

  const toggleCheckbox = (acaoToggle, nome) => {
    let changeObj = {};
    if (acaoToggle === acao.DESMARCAR) {
      changeObj.value = 0;
    } else {
      changeObj.value = 1;
    }
    props.handleChangeCheckbox(changeObj, nome);
  };

  const painelMensagemCampo = () => {
    if (User.logged().isRGPS()) {
      const mensagemCampoParagrafo1RGPS=(<p></p>);
      return (
        <React.Fragment>
          {mensagemCampoParagrafo1RGPS}
        </React.Fragment>
      );
    } else {
      const mensagemCampoParagrafo1RPPS=(<p>{ props.statePrincipal.alerta.mensagem }</p>);
      const mensagemCampoParagrafo2RPPS=(<p>{ props.statePrincipal.alerta.descricao }</p>);
      return (
        <React.Fragment>
          {mensagemCampoParagrafo1RPPS}
          {mensagemCampoParagrafo2RPPS}
        </React.Fragment>
      );
    }
  }

  const pesquisar = (
    <Button
      title="Pesquisar"
      onClick={() => props.handleSearchButton()}
      hint="Pesquisar dados pessoais"
    />
  );
  
  const pesquisarCpf = (
    <Button
      title="Pesquisar"
      onClick={() => props.handleSearchCpfButton()}
      hint="Pesquisar dados pessoais"
    />
  );

  const carimboSituacaoCtc = () => {
    let situacao = '';
    let situacaoCss = '';
    if (props.statePrincipal.ctc.versaoAtiva === 0 && props.statePrincipal.ctc.dtInvalidacao === null) {
      situacao = 'Rascunho';
      situacaoCss = 'situacaoCtcRascunho';
    } else if (props.statePrincipal.ctc.versaoAtiva === 0 && props.statePrincipal.ctc.dtInvalidacao !== null) {
      situacao = 'Inativa';
      situacaoCss = 'situacaoCtcInativa';
    } else if (props.statePrincipal.ctc.versaoAtiva === 1 && props.statePrincipal.ctc.dtInvalidacao === null) {
      situacao = 'Ativa';
      situacaoCss = 'situacaoCtcAtiva';
    }
    return (
      <React.Fragment>
        {(<div className={situacaoCss}>{situacao}</div>)}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      {props.statePrincipal.respostaPesquisaCtc === 'ctc-ja-emitida-para-a-matricula' &&
        <div style={(User.logged() && User.logged().isRGPS()) ? jssPainelMensagemCampoRGPS : jssPainelMensagemCampoRPPS}>
          <div style={jssMensagemDescricao}> 
            {painelMensagemCampo()}
          </div>
        </div>
      }
      {props.statePrincipal.ctc.versaoAtiva !== null &&
        <div style={jssCarimboSituacaoCtc}>
          <div className="left-sem-margem-direita">
            {carimboSituacaoCtc()}
          </div>
        </div>
      }
      <DataGrid title="Dados Pessoais" icon="ico-key" >
        <div className="row">
          <Grid cols="3 3 3 3">
            <Input
              cpf
              disabled={verificaSeCampoDesabilitado('cpf')}
              integer
              error={!props.statePrincipal.validadeCampos.cpf}
              touched={props.statePrincipal.touched || props.statePrincipal.cpfTouched}
              label="CPF"
              mask={Masks.cpf}
              value={props.statePrincipal.ctc.cpf}
              onChange={e => props.handleChange(e, 'cpf')}
              onKeyDown={e => props.handleKeyDown(e, 'cpf')}
              showMask
              required
            />
          </Grid>
          {(props.statePrincipal.estadoFormulario === 'inicial' ||
          props.statePrincipal.respostaPesquisaCtc === 'ctc-ja-emitida-para-a-matricula') &&
          <Grid cols="2 2 2 2">
            {pesquisar}
          </Grid>
          }
          {(props.statePrincipal.acao === 'novo' && props.statePrincipal.estadoFormulario !== 'inicial') &&
          <Grid cols="2 2 2 2">
            {pesquisarCpf}
          </Grid>
          }
        </div>
      </DataGrid>
      {props.exibirPainelPrincipalCtc() &&
      <div>
        <DataGrid title="Matrícula de Origem" icon="ico-tickets" >
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                disabled={verificaSeCampoDesabilitado('matricula1')}
                required
                error={'matricula1' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.matricula1 : false}
                label="Matrícula 1"
                maxLength="11"
                onChange={e => props.handleChange(e, 'matricula1')}
                touched={props.statePrincipal.touched}
                value={props.statePrincipal.ctc.matricula1}
                integer
              />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input
                disabled={verificaSeCampoDesabilitado('dtAdmissaoMat1')}
                error={'dtAdmissaoMat1' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.dtAdmissaoMat1 : false}
                label="Data de admissão"
                mask={Masks.date}
                value={props.statePrincipal.ctc.dtAdmissaoMat1}
                onChange={e => props.handleChange(e, 'dtAdmissaoMat1')}
                touched={props.statePrincipal.touched}
              />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input
                disabled={verificaSeCampoDesabilitado('dtDemissaoMat1')}
                error={'dtDemissaoMat1' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.dtDemissaoMat1 : false}
                label="Data da exoneração / demissão"
                mask={Masks.date}
                value={props.statePrincipal.ctc.dtDemissaoMat1}
                onChange={e => props.handleChange(e, 'dtDemissaoMat1')}
                touched={props.statePrincipal.touched}
              />
            </Grid>
          </div>
          <div className="row">
            <Grid cols="3 3 3 3">
              <input
                value={props.statePrincipal.informarSegundaMatricula}
                key="informarSegundaMatricula"
                label="Informar segunda matrícula"
                type="checkbox"
                checked={checked}
                onClick={() => toggleCheckbox(acaoAoClicar, 'informarSegundaMatricula')}
                style={{ paddingLeft: '5px', position: 'relative', top: '-10px' }}
                disabled={props.statePrincipal.desabilitarCheckboxSegundaMatricula}
              />
              <span style={{ paddingLeft: '5px', position: 'relative', top: '-11px' }}>informar segunda matricula</span>
            </Grid>
          </div>
          { (props.statePrincipal.informarSegundaMatricula === 1) &&
            <div className="row">
              <Grid cols="4 4 4 4">
                <Input
                  disabled={verificaSeCampoDesabilitado('matricula2')}
                  error={'matricula2' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.matricula2 : false}
                  label="Matrícula 2"
                  maxLength="11"
                  onChange={e => props.handleChange(e, 'matricula2')}
                  touched={props.statePrincipal.touched}
                  value={props.statePrincipal.ctc.matricula2}
                  integer
                />
              </Grid>
              <Grid cols="4 4 4 4">
                <Input
                  disabled={verificaSeCampoDesabilitado('dtAdmissaoMat2')}
                  error={'dtAdmissaoMat2' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.dtAdmissaoMat2 : false}
                  label="Data de admissão"
                  mask={Masks.date}
                  value={props.statePrincipal.ctc.dtAdmissaoMat2}
                  onChange={e => props.handleChange(e, 'dtAdmissaoMat2')}
                  touched={props.statePrincipal.touched}
                />
              </Grid>
              <Grid cols="4 4 4 4">
                <Input
                  disabled={verificaSeCampoDesabilitado('dtDemissaoMat2')}
                  error={'dtDemissaoMat2' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.dtDemissaoMat2 : false}
                  label="Data da exoneração / demissão"
                  mask={Masks.date}
                  value={props.statePrincipal.ctc.dtDemissaoMat2}
                  onChange={e => props.handleChange(e, 'dtDemissaoMat2')}
                  touched={props.statePrincipal.touched}
                />
              </Grid>
            </div>
          }
        </DataGrid>
        <DataGrid title="Dados da CTC" icon="ico-stamp">
            <div className="row">
              <Grid cols="4 4 4 4">
                <Input
                  disabled={verificaSeCampoDesabilitado('protocoloEmissor')}
                  required
                  error={'protocoloEmissor' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.protocoloEmissor: false}
                  label="Nº Protocolo"
                  onChange={e => props.handleChange(e, 'protocoloEmissor')}
                  touched={props.statePrincipal.touched}
                  value={props.statePrincipal.ctc.protocoloEmissor}
                  maxLength="23"
                  integer
                />
              </Grid>
            </div>
            <div className="row">
              <Grid cols="4 4 4 4">
                <Input
                  disabled={verificaSeCampoDesabilitado('cnpjEmissor')}
                  required
                  error={'cnpjEmissor' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.cnpjEmissor : false}
                  label="CNPJ do orgão emissor"
                  mask={Masks.cnpj}
                  onChange={e => props.handleChange(e, 'cnpjEmissor')}
                  touched={props.statePrincipal.touched}
                  value={props.statePrincipal.ctc.cnpjEmissor}
                  integer
                  exibirBotao={props.statePrincipal.acao === 'novo' ||
                    props.statePrincipal.acao === 'editar-rascunho' ||
                    props.statePrincipal.acao === 'revisar-ctc'}
                  onClickDoBotao={() => props.handleSearchCnpjButton('nomeEmissor', props.statePrincipal.ctc.cnpjEmissor)}
                  hintDoBotao="Pesquisar cnpj do orgão emissor"
                  iconeDoBotao="ico-doc-magnifier"
                />
              </Grid>
              <Grid cols="8 8 8 8">
                <Input
                  disabled={verificaSeCampoDesabilitado('nomeEmissor')}
                  error={'nomeEmissor' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.nomeEmissor : false}
                  label="Nome do orgão emissor"
                  required
                  maxLength="100"
                  onChange={e => props.handleChange(e, 'nomeEmissor')}
                  value={props.statePrincipal.ctc.nomeEmissor}
                  touched={props.statePrincipal.touched}
                />
              </Grid>
            </div>
            <div className="row">
              <Grid cols="4 4 4 4">
                <Input
                  disabled={verificaSeCampoDesabilitado('matriculaServidorEmissor')}
                  label="Matricula do servidor emissor"
                  maxLength="11"
                  onChange={e => props.handleChange(e, 'matriculaServidorEmissor')}
                  touched={props.statePrincipal.touched}
                  value={props.statePrincipal.ctc.matriculaServidorEmissor}
                  integer
                />
              </Grid>
              <Grid cols="8 8 8 8">
                <Input
                  disabled={verificaSeCampoDesabilitado('nomeServidorEmissor')}
                  error={'nomeServidorEmissor' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.nomeServidorEmissor : false}
                  label="Nome do servidor emissor"
                  // required
                  maxLength="100"
                  onChange={e => props.handleChange(e, 'nomeServidorEmissor')}
                  value={props.statePrincipal.ctc.nomeServidorEmissor}
                  touched={props.statePrincipal.touched}
                />
              </Grid>
            </div>
            <div className="row">
              <Grid cols="4 4 4 4">
                <Input
                  disabled={verificaSeCampoDesabilitado('cnpjHomologador')}
                  error={'cnpjHomologador' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.cnpjHomologador : false}
                  label="CNPJ do orgão homologador"
                  mask={Masks.cnpj}
                  onChange={e => props.handleChange(e, 'cnpjHomologador')}
                  touched={props.statePrincipal.touched}
                  value={props.statePrincipal.ctc.cnpjHomologador}
                  integer
                  exibirBotao={props.statePrincipal.acao === 'novo' ||
                    props.statePrincipal.acao === 'editar-rascunho' ||
                    props.statePrincipal.acao === 'revisar-ctc'}
                  onClickDoBotao={() => props.handleSearchCnpjButton('nomeHomologador', props.statePrincipal.ctc.cnpjHomologador)}
                  hintDoBotao="Pesquisar cnpj do orgão homologador"
                  iconeDoBotao="ico-doc-magnifier"
                />
              </Grid>
              <Grid cols="8 8 8 8">
                <Input
                  disabled={verificaSeCampoDesabilitado('nomeHomologador')}
                  error={'nomeHomologador' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.nomeHomologador : false}
                  label="Nome do orgão homologador"
                  maxLength="100"
                  onChange={e => props.handleChange(e, 'nomeHomologador')}
                  value={props.statePrincipal.ctc.nomeHomologador}
                  touched={props.statePrincipal.touched}
                />
              </Grid>
            </div>
            <div className="row">
              <Grid cols="4 4 4 4">
                <Input
                  disabled={verificaSeCampoDesabilitado('matriculaServidorHomologador')}
                  label="Matricula do servidor homologador"
                  maxLength="11"
                  onChange={e => props.handleChange(e, 'matriculaServidorHomologador')}
                  touched={props.statePrincipal.touched}
                  value={props.statePrincipal.ctc.matriculaServidorHomologador}
                  integer
                />
              </Grid>
              <Grid cols="8 8 8 8">
                <Input
                  disabled={verificaSeCampoDesabilitado('nomeServidorHomologador')}
                  error={'nomeServidorHomologador' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.nomeServidorHomologador : false}
                  label="Nome do servidor homologador"
                  maxLength="100"
                  onChange={e => props.handleChange(e, 'nomeServidorHomologador')}
                  value={props.statePrincipal.ctc.nomeServidorHomologador}
                  touched={props.statePrincipal.touched}
                />
              </Grid>
            </div>
            <div className="row">
              <Grid cols="4 4 4 4">
                <Input
                  disabled={verificaSeCampoDesabilitado('dtEmissao')}
                  required
                  error={'dtEmissao' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.dtEmissao : false}
                  label="Data de emissão"
                  mask={Masks.date}
                  value={props.statePrincipal.ctc.dtEmissao}
                  onChange={e => props.handleChange(e, 'dtEmissao')}
                  touched={props.statePrincipal.touched}
                />
              </Grid>
              <Grid cols="4 4 4 4 ">
                <Input
                  disabled={verificaSeCampoDesabilitado('tipoCtc')}
                  required
                  error={'tipoCtc' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.tipoCtc : false}
                  label="Tipo da CTC"
                  itemList={tipoCtc}
                  onChange={e => props.handleChange(e, 'tipoCtc')}
                  value={props.statePrincipal.ctc.tipoCtc}
                  touched={props.statePrincipal.touched}
                />
              </Grid>
            </div>
            <div className="row">
              <Grid cols="4 4 4 4">
                <Input
                  disabled={true}
                  label="Data de cadastro"
                  mask={Masks.date}
                  value={props.statePrincipal.ctc.dtCadastro}
                />
              </Grid>
              <Grid cols="4 4 4 4 ">
                <Input
                  disabled={true}
                  label="Cadastrado por:"
                  value={props.statePrincipal.ctc.nomeCadastrador}
                />
              </Grid>
            </div>
            {props.statePrincipal.ctc.dtInvalidacao !== null && 
              <div className="row">
                <Grid cols="4 4 4 4">
                  <Input
                    disabled={true}
                    label="Data de invalidação"
                    mask={Masks.date}
                    value={props.statePrincipal.ctc.dtInvalidacao}
                  />
                </Grid>
                <Grid cols="4 4 4 4 ">
                  <Input
                    disabled={true}
                    label="Invalidado por:"
                    value={props.statePrincipal.ctc.nomeInvalidador}
                  />
                </Grid>
              </div>
            }
        </DataGrid>
        <DataGrid title="Dados do Requerente" icon="ico-user" >
          <div className="row">
            <Grid cols="12 12 12 12">
              <Input
                disabled={verificaSeCampoDesabilitado('nome')}
                required
                error={'nome' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.nome : false}
                label="Nome"
                onChange={e => props.handleChange(e, 'nome')}
                value={props.statePrincipal.ctc.nome}
                touched={props.statePrincipal.touched}   
                />
            </Grid>
          </div>
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                disabled={verificaSeCampoDesabilitado('dtNascimentoRequerente')}
                required
                error={'dtNascimentoRequerente' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.dtNascimentoRequerente : false}
                label="Data de nascimento"
                mask={Masks.date}
                onChange={e => props.handleChange(e, 'dtNascimentoRequerente')}
                value={props.statePrincipal.ctc.dtNascimentoRequerente}
                touched={props.statePrincipal.touched} 
              />
            </Grid>         
            <Grid cols="4 4 4 4">
              <Input
                disabled={verificaSeCampoDesabilitado('sexo')}
                required
                error={'sexo' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.sexo : false}
                label="Sexo"              
                itemList={sexo}
                onChange={e => props.handleChange(e, 'sexo')}
                value={props.statePrincipal.ctc.sexo}
                touched={props.statePrincipal.touched}  
              />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input
                showMask
                disabled={verificaSeCampoDesabilitado('nit')}
                required
                error={'nit' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.nit : false}
                label="NIT/PIS/PASEP"
                onChange={e => props.handleChange(e, 'nit')}
                value={props.statePrincipal.ctc.nit}
                touched={props.statePrincipal.touched}  
                mask={Masks.nit}
                integer            
              />
            </Grid>
          </div>
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                disabled={verificaSeCampoDesabilitado('identidade')}
                error={'identidade' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.identidade : false}
                label="Número do documento de identidade"
                maxLength='11'
                onChange={e => props.handleChange(e, 'identidade')}
                value={props.statePrincipal.ctc.identidade}
                touched={props.statePrincipal.touched}
              />
            </Grid>         
            <Grid cols="4 4 4 4">
              <Input
                disabled={verificaSeCampoDesabilitado('identidadeEmissor')}
                error={'identidadeEmissor' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.identidadeEmissor : false}
                label="Orgão emissor da identidade"
                maxLength='100'
                onChange={e => props.handleChange(e, 'identidadeEmissor')}
                value={props.statePrincipal.ctc.identidadeEmissor}
                touched={props.statePrincipal.touched}              
              />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input
                disabled={verificaSeCampoDesabilitado('identidadeUf')}
                error={'identidadeUf' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.identidadeUf : false}
                label="UF do documento de identidade"
                itemList={ufs}
                onChange={e => props.handleChange(e, 'identidadeUf')}
                value={props.statePrincipal.ctc.identidadeUf}
                touched={props.statePrincipal.touched}              
                custom
              />
            </Grid>
          </div>
          <div className="row">
            <Grid cols="8 8 8 8">
              <Input
                disabled={verificaSeCampoDesabilitado('nomeMae') || props.statePrincipal.ctc.nomeMaeInexistente === 1}
                error={'nomeMae' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.nomeMae : false}
                label="Nome da mãe"
                maxLength='100'
                onChange={e => props.handleChange(e, 'nomeMae')}
                value={props.statePrincipal.ctc.nomeMae}
                touched={props.statePrincipal.touched}              
              />
            </Grid>
            <Grid cols="4 4 4 4">
              <input
                value={props.statePrincipal.ctc.nomeMaeInexistente}
                key="nomeMaeInexistente"
                label="Não consta nome da mãe"
                type="checkbox"
                checked={checkedNomeMae}
                onClick={() => toggleCheckbox(acaoAoClicarNomeMae, 'nomeMaeInexistente')}
                style={{ position: 'relative', top: '22px' }}
                disabled={props.statePrincipal.desabilitarCheckboxNomeMaeInexistente}
              />
              <span style={{ paddingLeft: '5px', position: 'relative', top: '21px' }}>não consta nome da mãe</span>
            </Grid>
          </div>
          <div className="row">
            <Grid cols="8 8 8 8">
              <Input
                disabled={verificaSeCampoDesabilitado('nomePai')}
                error={'nomePai' in props.statePrincipal.validadeCampos ? !props.statePrincipal.validadeCampos.nomePai : false}
                label="Nome do pai"
                maxLength='100'
                onChange={e => props.handleChange(e, 'nomePai')}
                value={props.statePrincipal.ctc.nomePai}
                touched={props.statePrincipal.touched}              
              />
            </Grid>
          </div>
        </DataGrid>
      </div>
      }
    </React.Fragment>
  );
};

DadosRepositorioCtc.propTypes = {
  acao: PropTypes.string.isRequired,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
  statePrincipal: PropTypes.objectOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleChangeCheckbox: PropTypes.func.isRequired,
  handleSearchButton: PropTypes.func.isRequired,
  handleKeyDown: PropTypes.func.isRequired,
  exibirPainelPrincipalCtc: PropTypes.func.isRequired,
  handleSearchCnpjButton: PropTypes.func.isRequired,
};

export default (DadosRepositorioCtc);



// WEBPACK FOOTER //
// ./src/pages/repositorio-ctc/DadosRepositorioCtc.jsx